import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface CountryCodeSelectorProps {
  value: string;
  onChange: (value: string) => void;
}

const countryCodes = [
  { code: "+1", country: "US" },
  { code: "+44", country: "UK" },
  { code: "+63", country: "PH" },
  //   { code: '+91', country: 'IN' },
  // Add more country codes as needed
];

export function CountryCodeSelector({
  value,
  onChange,
}: CountryCodeSelectorProps) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="h-12 w-[140px] rounded-[12px] border-[#e3dbcf] bg-[#faf4ea] text-sm text-black focus-visible:ring-2 focus-visible:ring-black/5">
        <SelectValue placeholder="Code" />
      </SelectTrigger>
      <SelectContent>
        {countryCodes.map((item) => (
          <SelectItem key={item.code} value={item.code}>
            {item.code} ({item.country})
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
